import { BASE_API } from "../Config/Config";

export const fetchorgchartdeleteapi = async (data, type) => {
    try {
        const formdata = new FormData();

        formdata.append("id", data?.id);
        formdata.append("parent_id", data?.parentId);
        formdata.append("type", type);

        const response = await fetch(
            `${BASE_API}/apis/orgchartDelete.php`,
            {
                method: "POST",
                body: formdata,
                credentials: "include"
            }
        );

        const result = await response.json();

        if (
            result.status === "success" &&
            Array.isArray(result.data)
        ) {
            return result.data;
        } else {
            return [];
        }
    } catch (err) {
        console.error("Fetch Error:", err);
        return [];
    }
};